export const authGuardedPaths = ["/checkout", "/myaccount"];
export const omitPaths = [
    "/zendesk-dialpad-connect",
    "/zendesk-authenticate",
    "/myaccount/gc-toolkit",
];
